//
//
//
//
//
//

export default {
  scrollToTop: false,
  async asyncData({ app, store, $content, params, redirect }) {
    if (!params.slug) {
      redirect('services/u-cash')
    }

    const page = await $content('services', params.slug).fetch()
    store.commit('pages/set', page)

    return {
      page
    }
  },
  created() {
    if (process.browser) {
      if (this.$route.hash === '#info') {
        const info = document.querySelector('[data-section="services-list"]')

        if (info) {
          window.scrollTo({
            top: info.offsetTop - 20,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
